<template>
  <div class="row pad-to-15">
    <div class="col-md-12 ">

      <!-- <div class="card-content row"> -->
        <div class="col-lg-10 col-md-12 card pad-to-15">
          <div class="pull-left">
            <el-input v-model="filters[0].value" placeholder="Search" class="icon-search"></el-input>
          </div>
          <data-tables class=""
                    v-loading="loading"
                    :data="tableData"
                    :search-def="searchDef"
                    :action-def="defaultActionDef"
                    :pagination-def="paginationDef"
                    :table-props="{'row-class-name': rowClass, 'border': false}"
                    :filters="filters"
                    @row-click="goToRecord"
                    style="width: 100%">
            <el-table-column
              :min-width="40"
              sortable
              prop="type"
              :label="$t('feedback.type')">
            
              <template slot-scope="props">
                <span class="label" :class="'label-' + feedbackTypeClass(props.row.type)" >{{$t('feedbackTypes.' + props.row.type)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              :min-width="60"
              sortable
              prop="sent_by"
              :label="$t('feedback.sentBy')">
              <template slot-scope="props">
                <template v-if="props.row.creater.firstname && props.row.creater.lastname">
                  {{props.row.creater.firstname}} {{props.row.creater.lastname}}
                </template>
                <template v-else>{{props.row.creater.email}}</template>
              </template>
            </el-table-column>
            <el-table-column
              :min-width="120"
              sortable
              prop="text"
              :label="$t('feedback.text')">
              <template slot-scope="props">
                {{limitChars(props.row.text, 100)}}
              </template>
            </el-table-column>
            <el-table-column
              :min-width="40"
              sortable
              prop="seen"
              :label="$t('feedback.seen')">
              <template slot-scope="props">
                {{props.row.seen ? 'seen' : 'new'}}
              </template>
            </el-table-column>
            <el-table-column
              :min-width="60"
              sortable
              prop="created_at"
              :label="$t('feedback.sentAt')">
              <template slot-scope="props">
                {{formatDateTime(props.row.created_at)}}
              </template>
            </el-table-column>
            <el-table-column
              :width="45">
              <template slot-scope="props"><i class="fa fa-pencil"></i></template>
            </el-table-column>
          </data-tables>
        </div>
      <!-- </div> -->
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input, Select, Option} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Input)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(DataTables)
  export default{
    components: {
      PPagination,
      PSwitch
    },
    computed: {
    },
    data () {
      return {
        loading: true,
        paginationDef: {
          pageSize: 10,
          currentPage: 1,
          pageSizes: [10, 25, 50],
          show: true
        },
        searchQuery: '',
        propsToSearch: ['name', 'status', 'type', 'discount'],
        tableColumns: [],
        tableData: [],
        filters: [
          {
            value: '',
            prop: ['name', 'text', 'seen', 'type']
          }
        ]
      }
    },
    created: function () {
      var self = this
      console.warn(this.$store.getters.loggedInUser)
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/feedback', 'GET', data, function (response) {
        if (response.status === true) {
          self.tableData = response.data
        }
        self.$nextTick(function () {
          self.loading = false
        })
      })
    },
    methods: {
      handleDelete (index, row) {
        var self = this
        var btnCounter = 3
        swal({
          text: `Are you sure you want to delete '${row.name}'?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: self.$t('general.yes') + ' (' + btnCounter + ')'
        })
        .then((result) => {
          if (result) {
            this.apiRequest('/hello', 'GET', [], function (response) {
              console.warn(response)
              if (response.status === true) {
                swal(
                  '',
                  'Push Notification deleted successfully',
                  'success'
                )
                self.tableData.splice(index, 1)
              } else {
                swal(
                  '',
                  'Something went wrong, please try again later...',
                  'error'
                )
              }
            })
          }
        })
        swal.disableConfirmButton()

        var btnInterval = setInterval(function () {
          btnCounter--

          if (btnCounter >= 1) {
            swal.getConfirmButton().textContent = 'Yes (' + btnCounter + ')'
          } else {
            swal.getConfirmButton().textContent = 'Yes'
            clearInterval(btnInterval)
            swal.enableConfirmButton()
          }
        }, 1000)
      },
      goToRecord (row, event, column) {
        this.globalGoToRecord(row, event, column, '/feedback/view/')
      },
      rowClass (row, index) {
        if (row.row.seen) {
          return ''
        } else {
          return 'new-feedback'
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Feedback/Feedback.vue